export const MSG_NOT_FOUND_USER_INFO = '회원인증이 필요한 서비스 입니다. 로그인 후 이용해 주세요.';
export const MSG_HAPPEN_TO_SAVE_ERROR = '저장중에 오류가 발생하였습니다. 다시 시도해 주세요.';
export const MSG_HAPPEN_TO_SEARCH_ERROR = '검색중에 오류가 발생하였습니다. 다시 시도해 주세요.';
export const MSG_HAPPEN_TO_LOAD_ERROR = '데이터를 불러오는 중에 오류가 발생하였습니다. 다시 시도해 주세요.';
export const MSG_MEMBER_SERVICE = '회원인증이 필요한 서비스 입니다. 로그인 후 이용해 주세요.';